// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","structure":"Banner_structure__TNOf6","colorVideo":"Banner_colorVideo__8pdyU","img":"Banner_img__TDZ7r","content":"Banner_content__Nyjud"};